
export const getHar = (data, date, listData) => {
    (data.elementos).map(elements=>{
        var newData={
          "startedDateTime": elements.params.inicio,
        "time": elements.params.duracion*1000,// muestra final de lo que duro barra
        "request": {
          "method": "GET",
          "url": elements.params.urlComplete.replace("blob:", ""),
          "headers": [
            {
              "name": "Accept-Encoding",
              "value": "gzip, deflate, sdch"
            },
          ],
          "queryString": [],
          "cookies": [],
        },
        "response": {
          "status": elements.params.estado,
          "headers": [
            {
              "name": "Content-Type",
              "value": elements.params.tipo
            },{
              "name": "cache-control",
              "value": "no-store, no-cache, must-revalidate, post-check=0, pre-check=0"
            },
          ],
          "cookies": [],
          "content": {
            "size": 0,
            "mimeType": elements.params.tipo,
          },
          "headersSize": 193,
          "bodySize": 0,
        },
        "cache": {},
        "timings": {
          "send":"",
          "blocked":-1,
          "dns":-1,
          "connect":-1,
          "wait":elements.params.latencia,
          "receive":elements.params.descarga*1000,
          "ssl":-1,
          "_queued":-1

        },
        "serverIPAddress":elements.params.ip,
        "pageref": "page_1"
        }
        listData.push(newData)
    });

    var har={
      "log": {
        "version": "1.2",
        "creator": {
          "name": "WebInspector",
          "version": "537.36"
        },
        "pages": [
          {
            "startedDateTime": (data.elementos[0].params.inicio),
            "id": "page_1",
            "title": data.elementos[0].params.urlComplete.replace("blob:", ""),
            "pageTimings": {
            }
          }
        ],
      "entries": listData
      }
    }

    return (har)
}